import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import * as feather from 'feather-icons';
import packageInfo from '../../../../../package.json';
import {LayoutSidebarComponent} from '../layout-sidebar/layout-sidebar.component';
import {LayoutNavbarComponent} from '../layout-navbar/layout-navbar.component';

@Component({
  selector: 'app-layout-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    LayoutSidebarComponent,
    LayoutNavbarComponent,
  ],
  templateUrl: './layout-wrapper.component.html',
  styleUrl: './layout-wrapper.component.scss'
})
export class LayoutWrapperComponent implements OnInit, AfterViewInit {
  year: any
  show: boolean = true;
  version: string = packageInfo.version;

  updateShow(newShowValue: boolean) {
    this.show = newShowValue; // Update the `show` value in the parent component
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

  ngAfterViewInit(): void {
    feather.replace();
  }

}
